import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dd53884"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "camera"
}
const _hoisted_2 = { class: "camera-text text-white text-center text-size-14 py-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "camera-close" }
const _hoisted_6 = {
  ref: "cameraFrameMask",
  class: "camera-frame-mask"
}
const _hoisted_7 = {
  key: 1,
  class: "fixed-button px-3 pt-3 pb-4"
}
const _hoisted_8 = {
  key: 2,
  class: "camera-footer"
}
const _hoisted_9 = { class: "camera-instruction" }
const _hoisted_10 = { class: "camera-button-wrapper" }
const _hoisted_11 = {
  key: 1,
  class: "preview"
}
const _hoisted_12 = { class: "main-container px-4 py-4" }
const _hoisted_13 = {
  key: 0,
  class: "image-description"
}
const _hoisted_14 = { class: "preview-image mt-4" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = { class: "sequence-list" }
const _hoisted_18 = { class: "action-area" }
const _hoisted_19 = { class: "footer-inner px-3 py-2" }
const _hoisted_20 = { class: "my-3 text-center" }
const _hoisted_21 = { class: "d-flex action-button-wrapper" }
const _hoisted_22 = { class: "text-center my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Header = _resolveComponent("Header")!
  const _component_BAvatar = _resolveComponent("BAvatar")!
  const _component_SequenceList = _resolveComponent("SequenceList")!
  const _component_SimpleCheckbox = _resolveComponent("SimpleCheckbox")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'bg-background': !_ctx.isCameraScreen }, "set-image-modal"]),
    ref: "setImageModal"
  }, [
    (_ctx.isCameraScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isAvatar)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("\n            枠内に顔全体を収めてください"),
                  _hoisted_3,
                  _createTextVNode("\n            帽子やマスク・イヤホンは外してください"),
                  _hoisted_4,
                  _createTextVNode("\n            正面を向いて目線はカメラに向けてください\n          ")
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_FeatherIcon, {
              icon: "x",
              stroke: "white",
              onClick: _ctx.onClickCameraClose
            }, null, 8, ["onClick"])
          ]),
          _createTextVNode(),
          (!_ctx.isAvatar)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([`camera-frame--${_ctx.photographingType}`, "camera-frame"])
              }, null, 2))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _withDirectives(_createElementVNode("canvas", _hoisted_6, null, 512), [
            [_vShow, _ctx.isAvatar]
          ]),
          _createTextVNode(),
          (_ctx.isAvatar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_AppButton, {
                  key: "shutter",
                  block: "",
                  class: "d-flex align-items-center justify-content-center",
                  disabled: !_ctx.isCameraActive,
                  onClick: _ctx.takePicture
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FeatherIcon, {
                      icon: "camera",
                      class: "mr-2"
                    }),
                    _createTextVNode("撮影する")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, "\n            [" + _toDisplayString(_ctx.photographingTypeLabel) + "の全体] が枠内に入るようにしてください\n          ", 1),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_AppButton, {
                    key: "shutter",
                    block: "",
                    class: "d-flex align-items-center justify-content-center camera-button",
                    disabled: !_ctx.isCameraActive,
                    onClick: _ctx.takePicture
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FeatherIcon, {
                        icon: "camera",
                        class: "mr-2"
                      }),
                      _createTextVNode("撮影する")
                    ], undefined, true),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]))
        ]))
      : (_ctx.isPreviewScreen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_Header, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.actionLabel) + "した写真の確認 ", 1)
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.imageDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.imageDescription), 1))
                : _createCommentVNode("", true),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.photographingType === 'avatar')
                  ? (_openBlock(), _createBlock(_component_BAvatar, {
                      key: 0,
                      src: _ctx.previewImageData,
                      variant: "mild",
                      size: "20rem"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.previewImageData
                    }, null, 8, _hoisted_15))
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_SequenceList, { items: _ctx.optionList }, null, 8, ["items"])
                ])
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_SimpleCheckbox, {
                        checked: _ctx.isImageConfirmed,
                        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isImageConfirmed) = $event)),
                        label: "上記の写真で問題ない"
                      }, null, 8, ["checked"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_AppButton, {
                        block: "",
                        onClick: _ctx.onClickApply,
                        disabled: !_ctx.isImageConfirmed,
                        class: "mt-0",
                        rounded: _ctx.roundedButton
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("OK")
                        ], undefined, true),
                        _: 1
                      }, 8, ["onClick", "disabled", "rounded"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "retry-link",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClickRetry && _ctx.onClickRetry(...args)), ["prevent"]))
                      }, "再" + _toDisplayString(_ctx.actionLabel), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("input", {
      ref: "selectImage",
      type: "file",
      name: "image-uploader",
      accept: "image/jpeg, image/png, image/gif, image/webp",
      class: "d-none",
      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeUpload(($event.target as HTMLInputElement).files?.[0]))),
      onCancel: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelFileSelect && _ctx.cancelFileSelect(...args)))
    }, null, 544),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ], 2))
}